import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceUtil } from '../util/service.util';
import { PagerComponent } from '../paginator/pager.component';


import { HttpService } from 'ems-oauth2-client';
import { HttpHeaders } from '@angular/common/http';
import { map, catchError , publishReplay, refCount} from 'rxjs/operators';
import { Ocorrencia } from './ocorrencia';

@Injectable()
export class OcorrenciaService extends ServiceUtil {

  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  private url = '/sae/ocorrencia/';


  constructor(
    private http: HttpService,
    private pagerComponent: PagerComponent
  ) {
    super();
  }

  // altera ou inclui Ocorrencia
  public update(estudo: Ocorrencia): Observable<Ocorrencia> {
    const body = JSON.stringify(estudo);
    if (!estudo.id) {
      return this.http
        .post(this.url, body)
        .pipe(map(response => <Ocorrencia>response),
             catchError(this.handleError),
             publishReplay(1),
             refCount());
    } else {
      return this.http
        .put(this.url + '/' + estudo.id, body)
        .pipe(map(response => <Ocorrencia>response),
              catchError(this.handleError),
              publishReplay(1),
              refCount());
    }
  }


  // recupera por id
  public getId(id: number): Observable<Ocorrencia> {
    return this.http
      .get(this.url + '/' + id)
      .pipe(map(this.extractObjectData),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
  }

  filtrar(filtro: Ocorrencia): Observable<Ocorrencia[]> {
    let colocaVirgula = false;
    let novaUrl = '{';
    if (filtro.codigoEstudoSocioEconomico) {
     novaUrl += 'codigoEstudoSocioEconomico:\'' + filtro.codigoEstudoSocioEconomico + '\'';
     colocaVirgula = true;
    }
    novaUrl +=  '}';

    const urlModify = this.pagerComponent.formatarUrl(this.url, novaUrl, 100, 0);

    return this.http.get(urlModify)
            .pipe(map(response => {
                return <Ocorrencia[]> response;
            }),
               catchError(this.handleError),
               publishReplay(1),
               refCount());
  }

  encerrarOcorrencia(ocorrencia: Ocorrencia): Observable<Ocorrencia> {
    const body = JSON.stringify(ocorrencia);

    return this.http.put(this.url + '/' + ocorrencia.id + '/encerrar', body)
    .pipe(map(response => <Ocorrencia> response),
        catchError(this.handleError),
        publishReplay(1),
        refCount());
  }

  // extrai lista da resposta http
  private extractListData(res: any) {
    return res as Ocorrencia[];
  }

  // extrai objeto da resposta http
  private extractObjectData(res: any) {
    return res as Ocorrencia;
  }

}
